<template>
  <div class="simulation-speed-select" ref="triggerRef">
    <button
        type="button"
        class="transparent font-size-20 simulation-speed-button"
        @click="toggleMenu"
    >
      <span>{{ modelValue }}x</span>
      <i class="bi bi-chevron-down simulation-speed-icon"></i>
    </button>

    <Teleport to="body">
      <div
          v-if="isOpen"
          ref="menuRef"
          class="simulation-speed-menu"
          :style="menuStyle"
      >
        <button
            v-for="value in options"
            :key="value"
            type="button"
            class="simulation-speed-option"
            :class="{'simulation-speed-option-selected': value === modelValue}"
            @click="selectValue(value)"
        >
          {{ value }}x
        </button>
      </div>
    </Teleport>
  </div>
</template>

<script>
export default {
  name: 'SimulationSpeedSelect',
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isOpen: false,
      menuStyle: {},
    };
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
    window.addEventListener('resize', this.updateMenuPosition);
    window.addEventListener('scroll', this.updateMenuPosition, true);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
    window.removeEventListener('resize', this.updateMenuPosition);
    window.removeEventListener('scroll', this.updateMenuPosition, true);
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$nextTick(this.updateMenuPosition);
      }
    },
    selectValue(value) {
      this.$emit('update:modelValue', value);
      this.isOpen = false;
    },
    updateMenuPosition() {
      if (!this.isOpen || !this.$refs.triggerRef) {
        return;
      }

      const rect = this.$refs.triggerRef.getBoundingClientRect();
      this.menuStyle = {
        position: 'fixed',
        top: `${rect.bottom + 4}px`,
        left: `${rect.left}px`,
        minWidth: `${rect.width}px`,
        zIndex: 2000,
      };
    },
    handleOutsideClick(event) {
      if (!this.isOpen) {
        return;
      }

      const trigger = this.$refs.triggerRef;
      const menu = this.$refs.menuRef;

      if (trigger?.contains(event.target) || menu?.contains(event.target)) {
        return;
      }

      this.isOpen = false;
    },
  },
};
</script>

<style scoped>
.simulation-speed-select {
  display: inline-flex;
}

.simulation-speed-button {
  border: none;
  background: transparent;
  color: #000;
  padding: 0;
  min-width: 3.6rem;
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
}

.simulation-speed-icon {
  font-size: 0.8rem;
}

.simulation-speed-menu {
  display: flex;
  flex-direction: column;
  padding: 0.25rem 0;
  background: #fff;
  border: 1px solid #d7d7d7;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.simulation-speed-option {
  border: none;
  background: transparent;
  color: #000;
  padding: 0.3rem 0.6rem;
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
}

.simulation-speed-option:hover,
.simulation-speed-option-selected {
  background: #f2f2f2;
}
</style>
